"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_ModalHeader = exports.Occ_ModalContent = exports.Occ_ModalContainer = exports.Occ_Modal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_ModalContainer = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    font-family: var(--font-family-primary);\n    z-index: var(--z-index-2);\n"])));
exports.Occ_ModalContainer = Occ_ModalContainer;
var Occ_Modal = (0, _styledComponents["default"])('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: absolute;\n    background-color: var(--color-base-white);\n    box-shadow: var(--box-shadow-xs);\n    border-radius: var(--border-radius-xs);\n    height: ", ";\n    top: 50%;\n    left: 50%;\n    transform: ", ";\n    padding: 5px;\n    width: ", ";\n    transition: all 0.2s ease-out;\n"])), function (props) {
  return props.height ? "".concat(props.height) : 'fit-content';
}, function (props) {
  return props.open ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0.5)';
}, function (props) {
  return props.width ? "".concat(props.width) : '300px';
});
exports.Occ_Modal = Occ_Modal;
var Occ_ModalHeader = (0, _styledComponents["default"])('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 10px;\n\n    svg {\n        position: absolute;\n        right: 8px;\n        top: 8px;\n        cursor: pointer;\n    }\n"])));
exports.Occ_ModalHeader = Occ_ModalHeader;
var Occ_ModalContent = (0, _styledComponents["default"])('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 10px 5px;\n    text-align: ", ";\n"])), function (props) {
  if (props.alignContent === 'start') {
    return 'start';
  } else if (props.alignContent === 'end') {
    return 'end';
  } else if (props.alignContent === 'center') {
    return 'center';
  }
});
exports.Occ_ModalContent = Occ_ModalContent;